import { authClient } from './client';
import ExtractErrorMessage from "../utils/extractErrorMessage";

const quizService = {

    getAll: async (page = 0, limit = 10, status = undefined, search = undefined) => {
        const params = new URLSearchParams();
        params.append('page', page.toString());
        params.append('limit', limit.toString());

        if (status) params.append('status', status);
        if (search) params.append('search', search);

        try {
            return (await authClient.get(`/quizzes/get-all?${params.toString()}`)).data;
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške");
            return { data: null, success: false, message: message };
        }
    },

    getById: async (id) => {
        try {
            return (await authClient.get(`/quizzes/${id}/get-one`)).data;
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške");
            return { data: null, success: false, message: message };
        }
    },

    create: async (data) => {
        try {
            return (await authClient.post('/quizzes/create', data)).data;
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške");
            return { data: null, success: false, message: message };
        }
    },

    update: async (id, data) => {
        try {
            return (await authClient.put(`/quizzes/${id}/update`, data)).data;
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške");
            return { data: null, success: false, message: message };
        }
    },

    delete: async (id) => {
        try {
            return await (await authClient.delete(`/quizzes/${id}/delete`)).data;
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške");
            return { data: null, success: false, message: message };
        }
    },

    toggleStatus: async (id) => {
        try {
            return (await authClient.patch(`/quizzes/${id}/toggle-status`, {})).data;
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške");
            return { data: null, success: false, message: message };
        }
    },

    getResponses: async (quizId, page = 0, limit = 10, search = undefined) => {
        const params = new URLSearchParams();
        params.append('page', page.toString());
        params.append('limit', limit.toString());
        if (search) params.append('search', search);

        try {
            return (await authClient.get(`/quizzes/${quizId}/responses?${params.toString()}`)).data;
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške");
            return { data: null, success: false, message: message };
        }
    },

    getResponseDetail: async (quizId, userId) => {
        try {
            return (await authClient.get(`/quizzes/${quizId}/responses/${userId}`)).data;
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške");
            return { data: null, success: false, message: message };
        }
    },
};

export default quizService;
